import {Component, Inject, OnInit} from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import { Configuration } from '../../../app.constants';

@Component({
  selector: 'app-image-gallery',
  templateUrl: './image-gallery.component.html',
  styleUrls: ['./image-gallery.component.css']
})
export class ImageGalleryComponent implements OnInit {

  public imageNumber = 0;
  public serverApiUrl;
  public image: any;
  public isMobile = false;
  // public dummyData = ["assets/img/gallery/img1.jpg","assets/img/gallery/img4.jpg","assets/img/gallery/img14.jpg","assets/img/gallery/img17.jpg"]
  constructor(public dialogRef: MatDialogRef<ImageGalleryComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public configuration: Configuration) {
      
      console.log('data', this.data.images)
      this.imageNumber = this.data.index;
      this.image = this.data.images[0].imageURL;
      // this.image = this.dummyData[0]
      this.isMobile = window.innerWidth < 768;

     }

  ngOnInit() {
    this.image = this.data.images[this.imageNumber].imageURL;
    this.serverApiUrl = this.configuration.StaticImageUrl;
  }
  changeImage(number:number){
    this.imageNumber=Number((this.imageNumber + number + this.data.images.length)%this.data.images.length );
    this.image=this.data.images[this.imageNumber].imageURL;
    // this.imageNumber=Number((this.imageNumber + number + this.dummyData.length)%this.dummyData.length );
    // this.image=this.dummyData[this.imageNumber];
  }

}
